/* eslint-disable */
import React, { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import {NavLink, Link} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../i18n';
import HeaderSearch from './search/HeaderSearch';
import { FaGlobe } from "react-icons/fa";
import { FiList } from "react-icons/fi";
import UserPopover from '../ass_overlay_components/UserPopover.js';
import 'react-phone-input-2/lib/style.css';

import { MenuOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';

const HeaderPastoral = ({ fixed, transparent }) => {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  // Language setup
  const language_code = useSelector((state) => state.lang)
  const itemCount = useSelector((state) =>
    state.cart.items.reduce((total, item) => total + item.quantity, 0)
  );
  
  const menuItems = (
    <>
      <NavLink to="/" onClick={handleClose}>
        {translate('agro_bottom_header', language_code.lang).home}
      </NavLink>
      <NavLink to="/producers" onClick={handleClose}>
        {translate('agro_bottom_header', language_code.lang).producer}
      </NavLink>
      <NavLink to="/speculators" onClick={handleClose}>
        Speculators
      </NavLink>
      <NavLink to="/traders" onClick={handleClose}>
        Traders
      </NavLink>
      <NavLink to="/pricing" onClick={handleClose}>
        Pricing
      </NavLink>
      <NavLink to="/resellers" onClick={handleClose}>
        {translate('agro_bottom_header', language_code.lang).regular}
      </NavLink>
    </>
  );

  return (
  <>
      <header className="header-upper py-3" onContextMenu={(e) => e.preventDefault()}>
          <div className='container-xxl'>
              <div className='row align-items-center'>

                  {/* LOGO with home redirection */}
                  <div className='col-6 col-md-3 col-xl-2'>
                      <Link to="/" className="logo-link" style={{ display: 'inline-block' }}>
                          <img
                              src="images/core_images/logo-transparent.png"
                              className="logo"
                              alt="logo"
                              onContextMenu={(e) => e.preventDefault()} // prevent right-click
                              draggable="false" // prevent drag
                              style={{ userSelect: 'none', pointerEvents: 'auto' }}
                          />
                      </Link>
                  </div>

                  {/* SEARCH BAR */}
                  <div className='col-12 col-md-5 order-3 order-md-2 mt-3 mt-md-0'>
                      <HeaderSearch />
                  </div>

                  {/* HEADER ICONS */}
                  <div className='col-6 col-md-4 col-xl-5 order-2 order-md-3'>
                      <div className='header-upper-links d-flex align-items-center justify-content-end justify-content-md-between gap-10'>

                          {/* COMPARATOR */}
                          <div className='d-none d-md-block'>
                              <Link className='header-options gap-10' to="/compare-products">
                                  <img src="images/icon-images/comparator.png" height='50' width='50' className="img-fluid rounded-3" alt="comparator"/>
                                  <p className="mb-0 header-option-label">
                                      {translate('agro_main_header', language_code.lang).comparator} <br />
                                      {translate('agro_main_header', language_code.lang).bio}
                                  </p>
                              </Link>
                          </div>

                          {/* WISHLIST */}
                          <div className='d-none d-md-block'>
                              <Link className='header-options gap-10' to="/wishlist">
                                  <img src="images/icon-images/favorite.png" height='50' width='50' className="img-fluid rounded-3" alt="wishlist"/>
                                  <p className="mb-0 header-option-label">
                                      {translate('agro_main_header', language_code.lang).favorite1} <br />
                                      {translate('agro_main_header', language_code.lang).favorite2}
                                  </p>
                              </Link>
                          </div>

                          {/* USER */}
                          <div className='userInfo'>
                              <Link className='header-options gap-10'>
                                  <img src="images/icon-images/account.png" height='50' width='50' className="img-fluid rounded-3" alt="account"/>
                                  <UserPopover />
                              </Link>
                          </div>

                          {/* CART */}
                          <div className='d-none d-md-block'>
                              <Link className='header-options gap-10' to="/cart">
                                  <img src="images/icon-images/shoppingcart4.png" height='50' width='50' className="img-fluid rounded-3" alt="cart"/>
                                  <div className='d-flex flex-column gap-10'>
                                      <span className='badge bg-white shopping-badge'>{itemCount}</span>
                                      <p className="mb-0 header-option-label">{translate('agro_main_header', language_code.lang).shopping1}</p>
                                  </div>
                              </Link>
                          </div>

                      </div>
                  </div>
              </div>
          </div>
      </header>
  <header className="header-bottom py-3">
    <div className='container-xxl'>
      <div className='row'>
        <div className='col-12'>
          <div className='menu-bottom d-flex align-items-center gap-30'>
            <div className='d-none d-md-block'>
              <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle bg-transparent border-0 gap-15 d-flex align-items-center" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                <FiList className='fs-7'/><span className='me-5 d-inline-block'>{translate('agro_bottom_header', language_code.lang).category}</span>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li><Link className="dropdown-item text-white" to="">{translate('agro_bottom_header', language_code.lang).spec1}</Link></li>
                  <li><Link className="dropdown-item text-white" to="">{translate('agro_bottom_header', language_code.lang).spec2}</Link></li>
                  <li><Link className="dropdown-item text-white" to="">{translate('agro_bottom_header', language_code.lang).spec3}</Link></li>
                    <li><Link className="dropdown-item text-white" to="">{translate('agro_bottom_header', language_code.lang).spec4}</Link></li>
                    <li><Link className="dropdown-item text-white" to="">{translate('agro_bottom_header', language_code.lang).spec5}</Link></li>
                </ul>
              </div>
            </div>
        

            {/* MENU DESKTOP */}
            <div className="menu-links desktop-only">
              <div className="d-flex align-items-center gap-15">
                {menuItems}
              </div>
            </div>

            {/* HAMBURGER MOBILE */}
            <div className="mobile-only hamburger-icon" onClick={() => setOpen(true)}>
              <MenuOutlined style={{ fontSize: '24px', color: 'white' }} />
            </div>

            {/* DRAWER MOBILE */}
            <Drawer
              placement="left"
              closable={true}
              onClose={handleClose}
              open={open}
              className="mobile-drawer"
            >
              <div className="d-flex flex-column gap-15">{menuItems}</div>
            </Drawer>
          </div>
        </div>
      </div>
    </div>
  </header>
  </>);
}
export default HeaderPastoral